<div>
  {{ 'you-impersonate-as' | translate }}
  <span class="name"> {{ name$ | async }} </span>
</div>

<button pso-button [size]="'s'" [color]="'primary-b-blue'" (click)="onEndImpersonatingClick()">
  {{ 'finish-impersonating' | translate | uppercase }}
</button>
